import { ArrowRight, MapPin, Star } from "lucide-react";

const HERO_BG =
  "https://images.pexels.com/photos/8985703/pexels-photo-8985703.jpeg";

export default function Hero({ onQuoteClick }) {
  return (
    <section
      id="accueil"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden grain"
    >
      <img
        src={HERO_BG}
        alt="Mécanicien travaillant sur un véhicule"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/30" />
      <div className="absolute inset-0 bg-black/20" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-32 w-full">
        <div className="max-w-3xl reveal">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 backdrop-blur px-3 py-1 mb-6">
            <MapPin size={14} className="text-blue-400" />
            <span className="text-xs font-medium tracking-wide text-white/90">
              Scientrier · Haute-Savoie
            </span>
          </div>

          <h1 className="font-display font-black text-white text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Garage automobile <br />
            <span className="text-white/60">multimarque</span>
            <span className="text-blue-400">.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg text-white/80 leading-relaxed reveal reveal-delay-1">
            Entretien rapide, fiable et compétitif. Plusieurs années
            d'expertise au service de votre véhicule, toutes marques confondues.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 reveal reveal-delay-2">
            <button
              onClick={onQuoteClick}
              data-testid="hero-cta-quote"
              className="lift group inline-flex items-center gap-2 rounded-md bg-blue-600 px-6 py-3.5 text-sm font-semibold text-white hover:bg-blue-700 shadow-lg shadow-blue-600/30"
            >
              Demander un devis gratuit
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="lift inline-flex items-center gap-2 rounded-md border border-white/30 bg-white/5 backdrop-blur px-6 py-3.5 text-sm font-semibold text-white hover:bg-white/10"
            >
              Voir nos services
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 max-w-md gap-6 reveal reveal-delay-3">
            <Stat value="9+" label="Années d'expertise" />
            <Stat value="100%" label="Multimarque" />
            <Stat
              value={
                <span className="flex items-center gap-1">
                  5 <Star size={18} className="fill-blue-400 text-blue-400" />
                </span>
              }
              label="Service de qualité"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div className="border-l border-white/20 pl-4">
      <div className="font-display font-black text-white text-2xl md:text-3xl">
        {value}
      </div>
      <div className="text-xs text-white/60 uppercase tracking-wider mt-1">
        {label}
      </div>
    </div>
  );
}
